import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../../shared/styles/theme';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.neutral.gray50};
`;

export const GridThree = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${spacing.lg};

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const GridTwo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing.lg};

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const InfoCard = styled.div`
  background: ${colors.neutral.white};
  padding: ${spacing.xl};
  border-radius: ${borderRadius.xl};
  border: 1px solid ${colors.neutral.gray200};
  box-shadow: ${shadows.sm};
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};

  svg {
    font-size: 2rem;
    color: ${colors.primary.orange};
  }
`;

export const CardTitle = styled.h3`
  font-size: ${typography.fontSize.xl};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.teal};
  margin: 0;
`;

export const CardText = styled.p`
  font-size: ${typography.fontSize.base};
  color: ${colors.neutral.gray600};
  line-height: ${typography.lineHeight.relaxed};
  margin: 0;
`;

export const PlaceholderBanner = styled.div`
  background: rgba(217, 125, 43, 0.1);
  border: 1.5px dashed ${colors.primary.orange};
  border-radius: ${borderRadius.lg};
  padding: ${spacing.md};
  color: ${colors.primary.orange};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.semibold};
  text-align: center;
  margin-bottom: ${spacing.md};
`;

export const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${borderRadius.full};
  background: ${colors.gradients.orange};
  color: ${colors.neutral.white};
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StepItem = styled.div`
  display: flex;
  gap: ${spacing.md};
  align-items: flex-start;
  background: ${colors.neutral.white};
  padding: ${spacing.lg};
  border-radius: ${borderRadius.xl};
  border: 1px solid ${colors.neutral.gray200};
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
`;

export const CommercialCTA = styled.div`
  background: ${colors.gradients.teal};
  color: ${colors.neutral.white};
  padding: ${spacing['2xl']} ${spacing.xl};
  border-radius: ${borderRadius['2xl']};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
  box-shadow: ${shadows.lg};
`;

export const CTATitle = styled.h3`
  font-size: ${typography.fontSize['2xl']};
  font-weight: ${typography.fontWeight.bold};
  margin: 0;
`;

export const CTAText = styled.p`
  font-size: ${typography.fontSize.lg};
  opacity: 0.9;
  margin: 0;
  max-width: 600px;
`;

export const CTAButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs};
  padding: 0.875rem 2rem;
  background: ${colors.primary.orange};
  color: ${colors.neutral.white};
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.base};
  border-radius: ${borderRadius.xl};
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: ${shadows.md};

  &:hover {
    background: ${colors.primary.orangeLight};
    transform: translateY(-2px);
    box-shadow: ${shadows.orangeHover};
  }
`;
